import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import DiscountCreateForm from '../DiscountCreateForm';

import * as Styles from './_productManagementDiscountDetails.module.scss';

const DiscountCreateModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.setting.modals.productManagementDiscountCreateModalIsOpen);
    const getSettingsError = useAppSelector(state => state.setting.errors.getSettings);
    const getSettingsIsLoading = useAppSelector(state => state.setting.loadings.getSettings);

    const handleModalOnClose = () => {
        dispatch(combinedActions.settingResetUpdateSettingsState());
        dispatch(combinedActions.settingSetProductManagementDiscountCreateModalIsOpen(!isOpen));
    };

    return (
        <Modal
            title='Create New Discount'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {getSettingsIsLoading
                ? (
                    <CustomClipLoader
                        blackBorder
                        className={Styles.loader}
                    />
                )
                : (getSettingsError
                    ? (
                        <Text
                            isError
                            label={getSettingsError}
                        />
                    )
                    : (
                        <div className={Styles.subcontainer}>
                            <DiscountCreateForm />
                        </div>
                    )
                )
            }
        </Modal>
    );
};

export default DiscountCreateModal;
